import { ReactNode, useCallback, useEffect, useState } from 'react';

import { PageId } from '../../apis';
import {
  CurrentPageView,
  PageTrackingContext,
} from '../../contexts/PageTrackingContext';

export const PageTrackingProvider = ({ children }: { children: ReactNode }) => {
  const [currentPageView, setCurrentPageView] = useState<CurrentPageView>({
    pageId: null,
    pageViewId: null,
  });

  const setPageView = useCallback((pageId: PageId, pageViewId: string) => {
    setCurrentPageView({ pageId, pageViewId });
  }, []);

  useEffect(() => {
    if (currentPageView.pageId) {
      document.body.dataset.trackDataPageId = currentPageView.pageId;
      document.body.dataset.trackDataPageViewId = currentPageView.pageViewId!;
    }
    return () => {
      delete document.body.dataset.trackDataPageId;
      delete document.body.dataset.trackDataPageViewId;
    };
  }, [currentPageView]);

  return (
    <PageTrackingContext.Provider value={{ currentPageView, setPageView }}>
      {children}
    </PageTrackingContext.Provider>
  );
};
